<div class="row mt-3 mb-3">

  <div class="col-md-6">
    <h4>Incidencias del cliente</h4>
  </div>

  <div class="col-md-6 text-right">

    <button
      class="btn btn-primary"
      (click)="openAddIncidentModal()">

      <i class="fa fa-plus"></i>
      Agregar incidencia

    </button>

  </div>

</div>

<div class="row">

  <div
    class="col-md-4 mb-3"
    *ngFor="let incident of incidents">

    <div class="card incident-card">

        <div class="card-header text-right">

            <button
                nbButton
                size="tiny"
                status="primary"
                class="mr-2"
                (click)="editIncident(incident)">

                <nb-icon icon="edit-outline"></nb-icon>

            </button>

            <button
                nbButton
                size="tiny"
                status="danger"
                (click)="deleteIncident(incident)">

                <nb-icon icon="trash-2-outline"></nb-icon>

            </button>

        </div>

      <div class="card-body">

        <p>
          <strong>Asistente:</strong>
          {{ incident.asistente }}
        </p>

        <p>
          <strong>Fecha:</strong>
          {{ incident.fechaIncidencia | date:'dd/MM/yyyy' }}
        </p>

        <p>
          <strong>Incidencia:</strong>
          {{ incident.titulo }}
        </p>

        <p>
          <strong>Comentarios del Cliente:</strong>
          {{ incident.comentariosSupervisor }}
        </p>

        <p>
          <strong>Comentarios MIA:</strong><br>
          {{ incident.comentarios }}
        </p>

      </div>

    </div>

  </div>

</div>